const rubleFormatter = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

/** Цена может отсутствовать — это валидное «по запросу», а не ошибка. */
export function formatPrice(price: number | null, unit: string | null): string {
  if (price === null) return 'Цена по запросу';
  const amount = rubleFormatter.format(price);
  return unit ? `${amount} / ${unit}` : amount;
}

export function formatMoney(amount: number): string {
  return rubleFormatter.format(amount);
}

export function formatDate(isoDate: string): string {
  return dateFormatter.format(new Date(isoDate));
}

const percentFormatter = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/**
 * Процент по-русски пишется через запятую: «7,5 %», а не «7.5%».
 * Целые проценты выводим без хвоста — «5 %», а не «5,00 %».
 */
export function formatPercent(value: number): string {
  return `${percentFormatter.format(value)} %`;
}

/** 79001234567 -> +7 (900) 123-45-67 */
export function formatPhone(digits: string): string {
  const match = /^7(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(digits);
  if (!match) return digits;
  return `+7 (${match[1]}) ${match[2]}-${match[3]}-${match[4]}`;
}
